"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ExpandableTextBlock = void 0;
var _mui = require("@ori-ui/mui");
var _react = require("react");
var _Localization = require("../../Localization");
var _constants = require("../../constants");
var _models = require("../../models");
var _utils = require("../../utils");
var _jsxRuntime = require("react/jsx-runtime");
const StyledTypography = (0, _mui.styled)(_mui.Typography)(({
  theme,
  ownerState: {
    expanded = false,
    visibleMoreButton = true,
    height = 0
  }
}) => ({
  position: 'relative',
  display: 'block',
  height: expanded ? `${height}px` : visibleMoreButton ? 'calc(3 * 1em * 1.4)' : 'auto',
  lineHeight: 1.4,
  marginTop: theme.spacing(0),
  transition: 'all .2s',
  overflow: visibleMoreButton ? 'hidden' : 'visible',
  marginBottom: visibleMoreButton ? theme.spacing(0) : theme.spacing(3)
}));
const OverlayWrapper = (0, _mui.styled)('div')(({
  ownerState: {
    expanded = false
  }
}) => ({
  position: 'absolute',
  top: 0,
  height: expanded ? 0 : 'calc(3em * 1.4)',
  width: '100%',
  background: 'linear-gradient(to bottom, transparent, white)'
}));
const StyledLink = (0, _mui.styled)(_mui.Link)(({
  theme,
  ownerState: {
    expanded = false
  }
}) => ({
  paddingBottom: 0,
  color: theme.palette.text.primary,
  fontSize: '12px',
  fontWeight: 'bold',
  textTransform: 'uppercase',
  marginTop: expanded ? theme.spacing(2) : theme.spacing(3),
  marginBottom: theme.spacing(6),
  textAlign: 'center',
  cursor: 'pointer',
  '& > span': {
    paddingBottom: theme.spacing(1),
    borderBottom: `2px solid ${theme.palette.grey[900]}`,
    lineHeight: 1
  }
}));
const ExpandableTextBlock = props => {
  const [isExpanded, setIsExpanded] = (0, _react.useState)(false);
  const [customTextHeight, setCustomTextHeight] = (0, _react.useState)(0);
  const {
    dataTestId,
    children
  } = props;
  const isMobile = (0, _utils.useIsMobile)();
  const customTextRef = (0, _react.useRef)(null);
  const customTextVisibilityLength = isMobile ? 300 : 440;
  const customTextLength = customTextRef.current?.innerText.length ?? 0;
  const customTextClientHeight = customTextRef.current?.clientHeight ?? 0;
  const isMoreTextVisible = customTextLength >= customTextVisibilityLength;
  const onResize = (0, _react.useCallback)(() => {
    window.addEventListener('resize', () => setCustomTextHeight(customTextClientHeight));
  }, [customTextClientHeight]);
  (0, _react.useEffect)(() => {
    setCustomTextHeight(customTextClientHeight);
    onResize();
  }, [customTextClientHeight, customTextRef, onResize]);
  (0, _react.useEffect)(() => {
    setCustomTextHeight(customTextRef.current?.clientHeight ?? 0);
  }, []);
  const expandButton = /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledLink, {
    underline: "none",
    ownerState: {
      expanded: isExpanded
    },
    "data-testid": dataTestId,
    onClick: () => setIsExpanded(!isExpanded),
    children: isExpanded ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_Localization.Localization, {
      defaultMessage: _constants.defaultTranslations.hide,
      id: _models.TranslationKey.hide
    }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_Localization.Localization, {
      defaultMessage: _constants.defaultTranslations.readMore,
      id: _models.TranslationKey.readMore
    })
  });
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_mui.Box, {
    display: "flex",
    flexDirection: "column",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(StyledTypography, {
      variant: "caption",
      align: "left",
      ownerState: {
        expanded: isExpanded,
        visibleMoreButton: isMoreTextVisible,
        height: customTextHeight
      },
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        ref: customTextRef,
        children: children
      }), isMoreTextVisible ? /*#__PURE__*/(0, _jsxRuntime.jsx)(OverlayWrapper, {
        ownerState: {
          expanded: isExpanded
        }
      }) : null]
    }), isMoreTextVisible ? expandButton : null]
  });
};
exports.ExpandableTextBlock = ExpandableTextBlock;
//# sourceMappingURL=ExpandableTextBlock.js.map